module.exports = __webpack_public_path__ + "img/micromall_renovation.78bdf4ca.png";